module.exports = __webpack_public_path__ + "img/p8.48646639.png";